import { render, staticRenderFns } from "./Lame.vue?vue&type=template&id=27c44999&scoped=true"
import script from "./Lame.vue?vue&type=script&lang=js"
export * from "./Lame.vue?vue&type=script&lang=js"
import style0 from "./Lame.vue?vue&type=style&index=0&id=27c44999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c44999",
  null
  
)

export default component.exports